<template lang="pug">
  
  .login-wrapper
    #login.login
      .login-desc 
      .login-container
        .login-form-wrapper(@keyup.enter="login")
          .logo-wrapper
            .logo
              //- img(src="./logo.png",:alt="title")
              div.logo_title 欢迎登陆
          form.login-form
            label.sr-only(for="login-account") 账号 
            .input-group(:class="isFocus===1?'input-group-active':''")
              i.icon.iconfont.icon-account(:class="isFocus===1? 'icon-active' : ''")
              input#login-account.form-control.input-lg(placeholder="账号",v-model="form.username",@focus="focusEvent(1)",@blur="focusEvent(0)")
            label.sr-only(for="login-password") 密码 
            .input-group(:class="isFocus===2?'input-group-active':''")
              i.icon.iconfont.icon-password(:class="isFocus===2 ? 'icon-active' : ''")
              input#login-password.form-control.input-lg(type="password",placeholder="密码",v-model="form.password",@focus="focusEvent(2)",@blur="focusEvent(0)")
              //- .checkbox.check-complete(@click="rememberMe")
            //- input#login-remember(type="checkbox",value="remember",v-model="remember")
            //- label
            //-     | 记住密码
            <div style='margin-top:20px'></div>
            <div title="是否显示滚动验证" v-if="checkStatus()">
              <drag-verify :width="width" :height="height" :text="text" :success-text="successText" :background="background" :progress-bar-bg="progressBarBg" :completed-bg="completedBg" :handler-bg="handlerBg" :handler-icon="handlerIcon" :text-size="textSize" :success-icon="successIcon" ref="Verify">
              </drag-verify>
            </div>
            .btn.btn-lg.btn-complete.btn-blocks.btn-blocks-left(@click="login",:class="{'disabled-left':buttonDisabled}") 立 即 登 录
            .btn.btn-lg.btn-complete.btn-blocks.btn-blocks-right.register(@click="dialogFormVisible = true",:class="{'disabled-right':buttonDisabled}") 注册 

            //注册弹框
            <el-dialog title="注册账号" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :show-close="false" width="200px" :close-on-click-modal="false">
              <el-form :model="form2">
                <el-form-item label="授权码" :label-width="formLabelWidth">
                  <el-input v-model="form2.authcode" placeholder="请输入授权码" auto-complete="off" style="width:300px;float:left"></el-input>
                  <el-button type="primary" style="margin-left:10px;float:left" @click="getRoleProof()">获取授权码</el-button>
                </el-form-item>
                <el-form-item label="用户名" :label-width="formLabelWidth">
                  <el-input v-model="form2.name" placeholder="请输入您想要的用户名" auto-complete="off" style="width:410px;"></el-input>
                </el-form-item>
                <el-form-item label="密码" :label-width="formLabelWidth">
                  <el-input type="password" v-model="form2.password1" placeholder="请输入密码" auto-complete="off" style="width:410px;"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" :label-width="formLabelWidth">
                  <el-input type="password" v-model="form2.password2" placeholder="请再次输入密码" auto-complete="off" style="width:410px;"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="toregister()" :loading="form2.state">提 交</el-button>
              </div>
            </el-dialog>
            //完善公司信息弹框
            <el-dialog title="完善公司信息" :visible.sync="dialogTableVisible" :modal-append-to-body="false" :show-close="false" width="200px" :close-on-click-modal="false">
              <el-form :model="form2">
                <el-form-item label="公司全称" :label-width="formLabelWidth">
                  <el-input v-model="form3.orgname1" placeholder="请您输入公司名称" auto-complete="off" style="width:370px;float:left"></el-input>
                </el-form-item>
                <el-form-item label="公司简称" :label-width="formLabelWidth">
                  <el-input v-model="form3.orgname2" placeholder="再输入公司的简称" auto-complete="off" style="width:370px;"></el-input>
                </el-form-item>
                <el-form-item label="公司logo" :label-width="formLabelWidth">
                  <el-input type="text" v-model="form3.orglogo" placeholder="请在此放入logo图片地址，或点击右边小按钮" auto-complete="off" style="width:370px;float:left" ></el-input>
                  <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"> 
                    <img v-if="imageUrl" :src="imageUrl" class="avatar"> <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="二级域名" :label-width="formLabelWidth">
                  <el-input type="text" v-model="form3.orgurl" placeholder="放入您公司官网的URL" auto-complete="off" style="width:370px;"></el-input>
                </el-form-item>
                <el-form-item label="备注" :label-width="formLabelWidth">
                  <el-input type="textarea" v-model="form3.orgremark" placeholder="备注信息" auto-complete="off" style="width:420px;line-height:23px;" :autosize="true" :maxlength="60"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="perfectOrg()" :loading="form3.state">提 交</el-button>
              </div>
            </el-dialog>
            
        .version-wrapper 
          //- .version-text {{version}}
          .text {{copyright}}
      
</template>
<style type="text/css">
  
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  .avatar {
    width: 30px;
    height: 30px;
    display: block;
  }
  .btn-blocks {
    display:block;
    float:left;
  }
  .btn-blocks-left {
    width: 10rem;
  }
  .btn-blocks-right {
    margin-left: 1rem;
    width: 7rem;
    background:#71C671;
    border-color:#F5E8B9;
  }
</style>

<script>
import { VERSION, SUBVERSION, encrypt } from '@/utils/common'
import { login, getAccount } from '@/utils/auth'
import axios from 'axios'
import 'font-awesome/css/font-awesome.min.css'
import dragVerify from 'vue-drag-verify'

var dragWidth = 300
var checkStatus = true
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  dragWidth = 200
  checkStatus = false
}

export default {
  name: 'login',
  components: {
    dragVerify
  },
  data () {
    return {
      title: '云抄表平台',
      version: `V${VERSION}.${SUBVERSION}`,
      remember: true,
      copyright: '2017 © 云抄表平台',
      status: false,
      form: {
        username: '',
        password: ''
      },
      isFocus: 0,
      dialogTableVisible: false,
      dialogFormVisible: false,
      form2: {
        name: '',
        password1: '',
        password2: '',
        authcode: '',
        state: false
      },
      form3: {
        orgname1: '',
        orgname2: '',
        orglogo: '',
        orgurl: '',
        orgremark: '',
        state: false
      },
      formLabelWidth: '120px',
      shouquanmaWidth: '70px',
      handlerIcon: 'fa fa-angle-double-right',
      successIcon: 'fa fa-check',
      background: '#cccccc',
      progressBarBg: '#28a745c2',
      completedBg: '#66cc66',
      handlerBg: '#fff',
      text: '请将滑块拖动到右侧',
      successText: '验证成功',
      width: dragWidth,
      height: 42,
      textSize: '16px',
      isCircle: 'true'
    }
  },
  computed: {
    buttonDisabled () {
      return this.form.username === '' || this.form.password === ''
    }
  },
  methods: {
    checkStatus () {
      return checkStatus
    },
    rememberMe () {
      this.remember = !this.remember
    },
    login () {
      if (checkStatus && !this.$refs.Verify.isPassing) {
        this.$message({
          message: '请完成验证',
          showClose: true,
          type: 'error'
        })
        return
      }
      if (!this.buttonDisabled) {
        login(this.form.username, this.form.password, () => {
          getAccount(response => {
            this.$router.replace(this.$route.query.redirect || '/')
          })
          this.$message({
            message: '登录成功',
            showClose: true,
            type: 'success'
          })
        })
      }
    },
    changePass () {
      if (this.form2.password1 === this.form2.password2) {
        this.status = true
      }
    },
    focusEvent (active) {
      if (active === 0) {
        this.isFocus = false
      } else {
        this.isFocus = active
      }
    },
    toregister () {
      this.changePass()
      if (!this.status) {
        this.$message({
          message: '密码不一致，请重新输入',
          showClose: true,
          type: 'info'
        })
        return
      }
      this.form2.state = true
      let urls = 'base/location/register/logins'
      axios.post(urls, {
        authCode: this.form2.authcode,
        username: this.form2.name,
        password: encrypt(this.form2.password2)
      }).then((res) => {
        if (res.data === 0) {
          this.$message({
            message: '验证码无效',
            showClose: true,
            type: 'error'
          })
        } else if (res.data === 1) {
          this.$message({
            message: '恭喜您注册成功!请填写公司信息，完成前请勿关闭本页面',
            showClose: true,
            type: 'success'
          })
          this.dialogTableVisible = true
        } else {
          this.$message({
            message: '用户名重复,再试一下吧~',
            showClose: true,
            type: 'error'
          })
        }
      })
      this.form2.state = false
    },
    getRoleProof () {
      this.$confirm('为了保障您注册使用安全，请您致电：400-8838-031，接通后按“1”（业务咨询）获取授权码，即可注册“云抄表®”账号！', '即刻获取您的授权码', {
        confirmButtonText: '我知道了',
        cancelButtonText: '不用',
        type: 'success ',
        center: true
      }).then(() => {
        this.dialogFormVisible = false
        this.dialogTableVisible = false
      }).catch(() => {
        this.dialogFormVisible = false
        this.dialogTableVisible = false
        this.$message({
          type: 'info',
          message: '感谢您的支持'
        })
      })
    },
    perfectOrg () {
      let urls = 'base/location/register/perfectOrg'
      let thisName = this.form2.name
      let password2 = this.form2.password2
      if (password2 === '') {
        this.$message({
          type: 'error',
          message: '请输入您的密码'
        })
        return
      }
      if (thisName === '') {
        this.$message({
          type: 'error',
          message: '检测不到您的账号，请输入'
        })
        return
      } else {
        this.form3.state = true
      }
      axios.post(urls, {
        orgName1: this.form3.orgname1,
        orgName2: this.form3.orgname2,
        orgLogo: this.form3.orglogo,
        orgUrl: this.form3.orgurl,
        loginName: thisName,
        passWord: encrypt(password2),
        remark: this.form3.orgremark
      }).then((res) => {
        if (res.data === 0) {
          this.$message({
            message: '用户未注册，无需填写公司信息，请您输入正确的用户',
            showClose: true,
            type: 'error'
          })
        } else if (res.data === 1) {
          this.$message({
            message: '完善成功!正在登录...',
            showClose: true,
            type: 'success'
          })
          if (this.form2.name !== '' && this.form2.password2 !== '') {
            this.form.username = this.form2.name
            this.form.password = this.form2.password2
          }
          this.login()
        } else if (res.data === -1) {
          this.$message({
            message: '可能您已完善公司信息，正在为您登录，请稍后',
            showClose: true,
            type: 'info'
          })
          if (this.form.username === '') {
            this.form.username = this.form2.name
          }
          if (this.form.password === '') {
            this.form.password = this.form2.password2
          }
          this.login()
        } else if (res.data === 2) {
          this.$message({
            message: '密码错误，请联系本人操作',
            showClose: true,
            type: 'error'
          })
        } else {
          this.$message({
            message: '系统异常，请联系管理员',
            showClose: true,
            type: 'error'
          })
        }
      })
      this.form3.state = false
    }
  }
}
</script>

<style lang="sass" scoped>
.register
  background:#71C671
  border-color:#F5E8B9
.login-wrapper
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
.login
  display: flex
  flex-direction: column
  background: url(./bg.jpg) no-repeat
  background-size: cover
  height: 100%
  overflow: auto
.login-container
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column
  height: 100%
  padding: 5rem 5rem 2.75rem
  background: rgba(255,255,255,.5)
  position: absolute
  right: 0
  box-shadow: 2px 0 10px #8bc1f2
.login-form-wrapper
  flex: 1 0 auto
  width: 100%
.login-form
  width: 100%
  padding: 30px 20px 20px
  .disabled-left
    background-color: #A4A4A4
    border-color: #A4A4A4
    opacity: 1
  .btn-complete.disabled-right
    background-color: #71C671
    border-color: #F5E8B9
    opacity: 1

.login-form-submit
  display: block
  width: 100%
  padding: 11px 19px
  font-size: 18px
  border-radius: 4px
#login-password
  margin-top: 12px
.version-wrapper
  text-align: right
  line-height: 1.6
  .version-text
    font-size: 1.2rem
.input-group
  border-bottom: 1px solid #dbdbdb
.input-group-active
  border-bottom: 1px solid #3a9ff2
.form-control,  
  border: 0
  background: transparent
  border-radius: 0
.form-control:focus
  border: 0
  background: transparent!important 
.btn-complete
  margin-top: 20px
.login-desc
  position: absolute
  bottom: 44px
  left: 78px
  color: #fff
  p
    font-size: 1rem
.icon-account
  padding-top: 10px
  font-size: 20px
  margin-right: 6px
.icon-password
  padding-top: 20px
  font-size: 22px
  margin-right: 6px
.icon-active
  color: #3a9ff2
.logo_title
  font-size: 26px
  margin: 10px
@media (min-width:300px) and (max-width:768px)
  .login-container
    width: 100%
  .login-desc
    display: none
  .btn-blocks-left
    width: 100%
  .btn-blocks-right
    width: 100%
    margin-left: 0
</style>



// WEBPACK FOOTER //
// index.vue?36236dfd